"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function BriefcaseClock16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 0H12V3H16V6H14V5H2V9H5V11H3L3 14H4.5V16H1L1 11H0V3H4V0ZM10 2V3H6V2H10ZM7 12V15L7.7229 14.2771C7.90169 14.4984 8.101 14.7024 8.3177 14.8867C9.13507 15.5819 10.2046 16 11.368 16C13.891 16 16 14.0199 16 11.5C16 8.98015 13.891 7 11.368 7C9.99763 7 8.758 7.57987 7.90656 8.50948C7.56139 8.88634 7.27904 9.3217 7.07804 9.80022L8.92196 10.5748C9.03165 10.3137 9.18736 10.0722 9.38143 9.86032C9.86102 9.3367 10.5688 9 11.368 9C12.8568 9 14 10.1539 14 11.5C14 12.8461 12.8568 14 11.368 14C10.6891 14 10.0766 13.7572 9.61347 13.3633C9.43526 13.2117 9.27987 13.0383 9.15148 12.8485L10 12H7Z", fill: "black" }));
}
function BriefcaseClock16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(BriefcaseClock16Svg, Object.assign({}, svgProps)));
}
exports.default = BriefcaseClock16;
//# sourceMappingURL=BriefcaseClock16.js.map